import React from 'react';
import { FaMusic, FaVolumeDown, FaVideo } from 'react-icons/fa';
import { RiLoopRightFill } from 'react-icons/ri';
import { AudioType } from '../../../../dorian-shared/types/audio/audio';
import { AudioStepAction } from '../../../../dorian-shared/types/audio/AudioStepSettingsType';
import { BranchStep, StepTypes } from '../../../../dorian-shared/types/branch/BranchStep';
import { useLoopingAudioDetection } from '../BranchNodeCards/hooks/useLoopingAudioDetection';
import styles from './BranchItemBadge.module.scss';
import { VideoStepsPopoverTrigger } from './VideoStepsPopoverTrigger';

type BranchItemBadgeProps = {
  steps: BranchStep[];
}

export function BranchItemBadge(props: BranchItemBadgeProps) {
  const { steps } = props;

  const isLoopingAudio = useLoopingAudioDetection(steps);

  // A step "has" audio only when an entry of that type is not the None scaffold —
  // every step carries a {SFX,none}+{Music,none} placeholder, so matching on type
  // alone counts every step. A None-action entry is a placeholder, not real audio.
  const sfxCount = steps.filter((step) => step.stepAudios?.some(
    (audio) => audio.type === AudioType.SFX && audio.action !== AudioStepAction.None,
  )).length;
  const musicCount = steps.filter((step) => step.stepAudios?.some(
    (audio) => audio.type === AudioType.Music && audio.action !== AudioStepAction.None,
  )).length;
  const videoCount = steps.filter((step) => step.stepTypeId === StepTypes.Video).length;
  const mediaCount = sfxCount + musicCount + videoCount;

  if (mediaCount === 0) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.soundContainer}>
        {musicCount > 0 && (
        <div className={styles.musicItem} title={`Steps with music: ${musicCount}${isLoopingAudio ? ' (includes looping audio)' : ''}`}>
          {isLoopingAudio && (
          <div
            className={styles.loopingAudioBadge}
            title="Node has looping audio"
          >
            <RiLoopRightFill size={18} />
          </div>
          )}
          <FaMusic size={18} />
          <div className="ml-1">
            {musicCount}
          </div>
        </div>
        )}
        {sfxCount > 0 && (
        <div className={styles.sfxItem} title={`Steps with SFX: ${sfxCount}`}>
          <FaVolumeDown size={18} />
          <div className="ml-1">
            {sfxCount}
          </div>
        </div>
        )}
        {videoCount > 0 && (
          <VideoStepsPopoverTrigger steps={steps}>
            <div className={styles.videoItem} title="">
              <FaVideo size={18} />
              <div className="ml-1">
                {videoCount}
              </div>
            </div>
          </VideoStepsPopoverTrigger>
        )}
      </div>
    </div>
  );
}
